export const ParticipantStatus = {
    Active: 1,
    Present: 2,
    Absent: 3,
    Cancelled: 4,
    Deleted: 5,
  };
  
  export default function getParticipantStatusStyle(status) {
    switch (status) {
      case ParticipantStatus.Active:
        return {
          label: "Aktywnx",
          icon: "fa-user",
          statusClass: "participantstatus-darkgray",
          strikeThrough: false,
        };
      case ParticipantStatus.Present:
        return {
          label: "Obecnx",
          icon: "fa-user-check",
          statusClass: "participantstatus-blue",
          strikeThrough: false,
        };
      case ParticipantStatus.Absent:
        return {
          label: "Nieobecnx",
          icon: "fa-user-xmark",
          statusClass: "participantstatus-red",
          strikeThrough: false,
        };
      case ParticipantStatus.Cancelled:
        return {
          label: "Anulowanx",
          icon: "fa-user-slash",
          statusClass: "participantstatus-navy",
          strikeThrough: false,
        };
      case ParticipantStatus.Deleted:
        return {
          label: "Usuniętx",
          icon: "fa-user",
          statusClass: "participantstatus-lightgray",
          strikeThrough: true,
        };
      default:
        return {
          label: "Nieznany",
          icon: "fa-user",
          statusClass: "participantstatus-unknown",
        };
    }
  }
  